import * as Sentry from '@sentry/react';

const { SENTRY_DSN, STAGE, VERSION } = process.env;
Sentry.init({ dsn: SENTRY_DSN, environment: STAGE, release: VERSION });
